import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Home from './pages/Home';
import BankDetails from './pages/BankDetails';
import RedeemCash from './pages/RedeemCash';
import { Toaster } from './components/ui/toaster';
import ScrollToTop from './utils/ScrollToTop';
// import UpiPage from './pages/UpiPage'; // UPI disabled for now
import UpiConfirmPage from './pages/UpiConfirmPage';
import Signup from './pages/Signup';
import BackButtonHandler from './components/BackButtonHandler';
import useAutoLogout from './utils/useAutoLogout.js';
import useOnlineStatus from './hooks/useOnlineStatus';
import ProtectedRoute from './utils/ProtectedRoute';
import PublicRoute from './utils/PublicRoute';
import NotFound from './pages/NotFound';
import Profile from './pages/Profile';
import Language from './pages/Language';
import SloganPage from './pages/SloganPage';
import Transactions from './pages/Transactions';
import ProfileSetupRoute from './utils/ProfileSetupRoute';
import ProfileSetup from './pages/ProfileSetup';
import useDocumentTitle from './pages/Usedocumenttitle';



function App() {
useDocumentTitle();
  useAutoLogout(30);
  const isOnline = useOnlineStatus();
  return (
    <div className="App">
      {!isOnline && (
        <div className="fixed top-0 w-full bg-red-600 text-white text-center py-2 shadow-lg z-[9999]">
          📡 You are offline
        </div>
      )}
      <BrowserRouter>
        <BackButtonHandler />
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<PublicRoute><Language /></PublicRoute>} />
            <Route path="/:code" element={<PublicRoute><Language /></PublicRoute>} />
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            {/* <Route path="/sign-up" element={<PublicRoute><Signup /></PublicRoute>} /> */}
            <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/bank-details" element={<ProtectedRoute><BankDetails /></ProtectedRoute>} />
            <Route path="/redeem-cash" element={<ProtectedRoute><RedeemCash /></ProtectedRoute>} />
            {/* UPI disabled for now */}
            {/* <Route path="/upi-details" element={<ProtectedRoute><UpiPage /></ProtectedRoute>} /> */}
            <Route path="/upi-confirm" element={<ProtectedRoute><UpiConfirmPage /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
             <Route path="/slogan" element={<ProtectedRoute><SloganPage /></ProtectedRoute>} />
             <Route path="/transactions" element={<ProtectedRoute><Transactions /></ProtectedRoute>} />

              <Route
              path="/profile-setup"
              element={
                <ProfileSetupRoute>
                  <ProfileSetup />
                </ProfileSetupRoute>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </ScrollToTop>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
